import { createContext, useContext, useState } from "react"
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import CircleIcon from '@mui/icons-material/Circle';

export const UtilesContext = createContext()


export const useUtiles = () => {
    return useContext(UtilesContext)
}

export const UtilesProvider = ({ children }) => {



    const [openSilder, setOpenSilder] = useState(false)
    const [componentSilder, setComponentSilder] = useState(null)
    const [widthSilder, setWidthSilder] = useState(500)
    const [titleSilder, setTitleSilder] = useState('')
    const [loadingApi, setLoadingApi] = useState(false)
    // Estado para guardar el componente anterior y sus propiedades
    const [previousComponentState, setPreviousComponentState] = useState(null)


    const [alertSnackbar, setAlertSnackbar] = useState({
        open: false,
        message: '',
        severity: 'error'
    })


    /*const [ priorityOptions, setPriorityOptions ] = useState([
        { label: 'Muy Alta', value: 'Muy Alta', icon: <KeyboardDoubleArrowUpIcon color="error" /> },
        { label: 'Alta', value: 'Alta', icon: <ArrowUpwardIcon color="error" /> },
        { label: 'Media', value: 'Media', icon: <CircleIcon color="info" sx={{ fontSize: '16px', mr: 1 }} /> },
        { label: 'Baja', value: 'Baja', icon: <ArrowDownwardIcon color="success" /> },
        { label: 'Muy Baja', value: 'Muy Baja', icon: <KeyboardDoubleArrowDownIcon color="success" /> },
        
    ])*/

        const [ priorityOptions, setPriorityOptions ] = useState([
            { label: 'Alta (24h)', value: 'Alta', icon: <CircleIcon color="error" sx={{ mr: 1 }}/>, time_estimate: '024:00' },
            { label: 'Media (07 días)', value: 'Media', icon: <CircleIcon  sx={{ mr: 1, color: '#f1c40f' }}/>, time_estimate: '168:00' },
            { label: 'Baja (30 días)', value: 'Baja', icon: <CircleIcon color="success" sx={{ mr: 1 }}/>, time_estimate: '720:00' },
            
        ]) 

    const [ unitOptions, setUnitOptions ] = useState([
        { label: 'Unidad (UN)', value: 'unidad' },
        { label: 'Litro (Lt)', value: 'litro' },
        { label: 'Kilogramo (Kg)', value: 'kilogramo' },
        { label: 'Gramo (G)', value: 'gramo' },
        { label: 'Galón (M3)', value: 'galon' },
        { label: 'Par', value: 'par' },
        { label: 'Kit', value: 'kit' },
        { label: 'Metro (M)', value: 'metro' },
        { label: 'Centímetro (Cm)', value: 'centimetro' },
        { label: 'Rollo', value: 'rollo' },
        { label: 'Bolsa', value: 'bolsa' },
        { label: 'Caja', value: 'caja' },
        { label: 'Tubo', value: 'tubo' },
        { label: 'Otro', value: 'otro' }
    ])


    const statusOptions = [
        { label: 'Pendiente', value: 'pending', icon: <CircleIcon color="primary" />, color: 'primary' },
        { label: 'En Proceso', value: 'in_process', icon: <CircleIcon color="info" />, color: 'info' },
        { label: 'Completado', value: 'completed', icon: <CircleIcon color="success" />, color: 'success' },
        { label: 'Cancelado', value: 'cancel', icon: <CircleIcon color="error" />, color: 'error' },
        { label: 'En revisión', value: 'review', icon: <CircleIcon color="warning" />, color: 'warning' }
        
    ]
    

    const toogleOpenSilder = (componentOrEvent, width, title) => {
        // Check if the first argument is an event object (from event handlers)
        const isEvent = componentOrEvent && componentOrEvent.nativeEvent !== undefined;
        
        if (isEvent) {
            // When called from onClose event (click outside), just close without toggling
            setOpenSilder(false);
            setComponentSilder(null);
        } else {
            // Normal toggle behavior when called programmatically
            const newOpenState = !openSilder;
            setOpenSilder(newOpenState);
            
            if (width !== undefined) setWidthSilder(width);
            if (title !== undefined) setTitleSilder(title);
            
            // Only set component when opening, clear when closing
            setComponentSilder(newOpenState ? componentOrEvent : null);
        }
    }

    // Función para abrir un componente directamente
    const openSilderWith = (component, width, title) => {
        setOpenSilder(true)
        setComponentSilder(component)
        setWidthSilder(width)
        setTitleSilder(title)
    }

    //reset openSilder
    const resetOpenSilder = () => {
        setOpenSilder(false)
        setComponentSilder(null)
        setWidthSilder(500)
        setTitleSilder('')
    }

    // Función para guardar el componente actual
    const saveCurrentComponent = () => {
        if (componentSilder) {
            setPreviousComponentState({
                component: componentSilder,
                width: widthSilder,
                title: titleSilder
            })
        }
    }

    
    
    // Función para restaurar el componente anterior
    const restorePreviousComponent = () => {
        if (previousComponentState) {
            setOpenSilder(true)
            setComponentSilder(previousComponentState.component)
            setWidthSilder(previousComponentState.width)
            setTitleSilder(previousComponentState.title)
            setPreviousComponentState(null)
        } else {
            // Si no hay componente anterior, simplemente cerrar
            setOpenSilder(false)
            setComponentSilder(null)
        }
    }
    
    const locationString = (parent) => {
        if (!parent) return '//';
        
        // Array to store all parent names
        const parentNames = [];
        let currentParent = parent;
        
        // Traverse up the parent hierarchy
        while (currentParent) {
            parentNames.push(currentParent.name);
            currentParent = currentParent.parent;
        }
        
        // Reverse the array so that top-level parent comes first
        parentNames.reverse();
        
        // Format the string with slashes
        return '// ' + parentNames.join(' / ') + ' /';
    }


    //Generar un codigo aleatorio incluyendo fecha, minutos y segundos irrepetible
    const generateRandomCode = () => {
        const date = new Date()
        const timestamp = date.getTime().toString()
        
        // Crear partes aleatorias para asegurar unicidad
        const randomPart1 = Math.random().toString(36).substring(2, 10)
        const randomPart2 = Math.random().toString(36).substring(2, 10)
        const randomPart3 = Math.random().toString(36).substring(2, 10)
        
        // Combinar timestamp con partes aleatorias
        let code = timestamp + randomPart1 + randomPart2 + randomPart3
        
        // Asegurar que tenga exactamente 26 caracteres
        if (code.length > 26) {
            code = code.substring(0, 26)
        } else if (code.length < 26) {
            // Rellenar con más caracteres aleatorios si es necesario
            code = code.padEnd(26, Math.random().toString(36).substring(2))
        }
        
        return code
    }

    // Obtiene el primer nombre y primer apellido de un nombre completo
    const getFirstNameAndLastName = (fullName) => {
        if (!fullName) return '';
        
        // Dividir el nombre completo en partes
        const nameParts = fullName.trim().split(' ');
        
        // Si solo hay una parte, devolverla
        if (nameParts.length === 1) {
            return nameParts[0];
        }
        
        // Obtener el primer nombre
        const firstName = nameParts[0];
        
        // Obtener el primer apellido (penúltima parte si hay más de 2 partes, 
        // o última parte si solo hay 2)
        const lastName = nameParts.length > 2 ? 
            nameParts[nameParts.length - 2] : 
            nameParts[nameParts.length - 1];
        
        return `${firstName} ${lastName}`;
    }


    //Convertir horas y minutos a días y horas en formato 00Días 00h:00m
    //Dato de entrada 000:00
    //Dato de salida 00Días 00h:00m
    const convertHoursToDaysAndHours = (timeStr) => {
        const [hours, minutes] = timeStr.split(':').map(part => parseInt(part, 10));
        const days = Math.floor(hours / 24);
        const remainingHours = hours % 24;

        //Si no hay horas ni minutos, solo devolver los dias
        if (remainingHours === 0 && minutes === 0) {
            return `${days}Días`;
        }
        else {
            return `${days}Días ${remainingHours}h:${minutes}m`;
        }
    }


    //SUMAR HORAS Y MINUTOS DE LAS TAREAS
    //EN FORMATO 000:00
    //YA NO SE USA ESTE METODO

    const sumaTimeDurationTask = (taskList) => {
        // Inicializar contadores para horas y minutos
        let totalHours = 0;
        let totalMinutes = 0;
        
        taskList.forEach(task => {
            // Obtener el string de tiempo "000:00"
            const timeStr = task.time_duration;
            
            // Separar horas y minutos
            const [hours, minutes] = timeStr.split(':').map(part => parseInt(part, 10));
            
            // Sumar al total
            totalHours += hours;
            totalMinutes += minutes;
        });
        
        // Ajustar si los minutos exceden 59
        totalHours += Math.floor(totalMinutes / 60);
        totalMinutes = totalMinutes % 60;
        
        // Limitar a 999:59 como máximo
        if (totalHours > 999) {
            totalHours = 999;
            totalMinutes = 59;
        }
        
        // Formatear el resultado como "000:00"
        const formattedHours = totalHours.toString().padStart(3, '0');
        const formattedMinutes = totalMinutes.toString().padStart(2, '0');
        
        return `${formattedHours}:${formattedMinutes}`;
    }




    return (
        <UtilesContext.Provider value={{ 
            locationString, 
            openSilder, 
            componentSilder, 
            toogleOpenSilder, 
            widthSilder, 
            titleSilder, 
            setComponentSilder, 
            alertSnackbar, 
            setAlertSnackbar,
            saveCurrentComponent,
            restorePreviousComponent,
            openSilderWith,
            priorityOptions,
            resetOpenSilder,
            generateRandomCode,
            getFirstNameAndLastName,
            sumaTimeDurationTask,
            convertHoursToDaysAndHours,
            unitOptions,
            statusOptions,
            loadingApi,
            setLoadingApi,
        }}>
            {children}
        </UtilesContext.Provider>
    )
}